var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{staticClass:"main",attrs:{"alt":"Index Image","src":"https://teleportal-files.s3-ap-southeast-2.amazonaws.com/index.png"}}),_c('HelloWorld')],1)}
var staticRenderFns = []

export { render, staticRenderFns }